import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Divider,
  Fade,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Box,
  Modal,
  Typography
} from "@mui/material";
// Icons
import CloseIcon from "@mui/icons-material/Close";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import PersonIcon from "@mui/icons-material/Person";
import WatchLaterRoundedIcon from "@mui/icons-material/WatchLaterRounded";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
// API & Constants
import { Postrequestcall } from "../../../request/Postrequest";
import { BIGrey } from "../../../assets/helpers";
import {
  DELETE_CLIENT_TIMESHEET_TEMPLATES,
  FETCH_CLIENT_TIMESHEET_TEMPLATES_V2_NEW,
  SAVE_CLIENT_TIMESHEET_TEMPLATE
} from "../../../constant/Apipath";
// CSS & Components
import "../../../assets/css/ClientHome.css";
import TimesheetSkeletonLoader from "./components/TimesheetSkeletonLoader";

import ClientTimesheetCrewComponent from "../crew/CrewTimesheetSetup";
import ClientTimesheetManualComponent from "../individual/manual/ManualTimesheetController";
import ClientTimesheetClockinComponent from "../individual/clockInOut/ClockInTimesheetController";
import CrewTemplateForm from "../crew/templates/CrewTemplateForm";
import CrewTemplateView from "../crew/templates/CrewTemplateView";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

// Constants
const VIEWS = {
  MANUAL: "MANUAL",
  CLOCKIN: "CLOCKIN",
  CREW: "CREW",
  INDIVIDUAL_CLOCKIN: "INDIVIDUAL-CLOCKIN",
  NEW_TEMPLATE: "NEW-TEMPLATE",
  HOME: "HOME",
  LISTING_SELECT: "LISTING-SELECT",
  VIEW_TEMPLATE: "VIEW-TEMPLATE",
  EDIT_TEMPLATE: "EDIT_TEMPLATE"
};

// Sub-components
const TemplateItem = ({ data, onEdit, onDuplicate, onDelete, onView }) => {
  const { selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const clientAccentColor = selectedClientData?.AccentColor ?? "black";
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const {
    TEXT_ACTIVITIES,
    TEXT_EMPLOYEE,
    TEXT_TEMPLATE_EDIT,
    TEXT_DUPLICATE_TEMPLATE,
    TEXT_DELETE
  } = ClientEnglishFallback?.ClientTimesheetAddModal(
    multiLanguageData?.ClientTimesheetAddModal || {}
  );

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Stack
        sx={{
          padding: "5px",
          border: "1px solid #e4e4e4",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          minWidth: "30%",
          maxWidth: "30%",
          cursor: "pointer"
        }}
        onClick={() => onView(data)}>
        <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction="row">
          <Typography sx={{ wordBreak: "break-all",
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 1, fontSize: "15px", fontWeight: "bold" }}>
            {data?.name}
          </Typography>
          <IconButton size="small" onClick={(e) => handleClick(e)}>
            <MoreHorizIcon />
          </IconButton>
        </Stack>
        <Typography
          sx={{
            wordBreak: "break-all",
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 1,
            fontSize: "14px"
          }}>
          {data?.clientJobCode} - {data?.clientJobName}
        </Typography>
        <Typography sx={{ color: BIGrey }}>
          {data?.noOfActivities} {TEXT_ACTIVITIES}
        </Typography>
        <Typography sx={{ color: BIGrey }}>
          {data?.noOfEmployees} {TEXT_EMPLOYEE}
        </Typography>
      </Stack>

      <Menu
        id="template-menu"
        MenuListProps={{ "aria-labelledby": "template-button" }}
        sx={{ borderRadius: "10px" }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}>
        <MenuItem
          dense
          onClick={() => {
            onEdit(data);
            handleClose();
          }}>
          <Stack direction="row"  sx={{ gap: 1, alignItems: "center" }}>
            <EditIcon sx={{ color: clientAccentColor, height: "20px", width: "20px" }} />
            <Typography>{TEXT_TEMPLATE_EDIT}</Typography>
          </Stack>
        </MenuItem>

        <MenuItem
          dense
          onClick={() => {
            onDuplicate(data);
            handleClose();
          }}>
          <Stack direction="row"  sx={{ gap: 1, alignItems: "center" }}>
            <ContentCopyIcon sx={{ color: clientAccentColor, height: "20px", width: "20px" }} />
            <Typography>{TEXT_DUPLICATE_TEMPLATE}</Typography>
          </Stack>
        </MenuItem>

        <MenuItem
          dense
          onClick={() => {
            onDelete(data);
            handleClose();
          }}>
          <Stack direction="row"  sx={{ gap: 1, alignItems: "center" }}>
            <Delete sx={{ color: clientAccentColor, height: "20px", width: "20px" }} />
            <Typography>{TEXT_DELETE}</Typography>
          </Stack>
        </MenuItem>
      </Menu>
    </>
  );
};

// Main Component
const ClientTimesheetAddModal = ({
  showAddClientTimesheetModal,
  handleClose,
  setTimeSheetData,
  onAddIndividualTimesheet,
  onAddCrewTimesheet,
  timeSheetData,
  setViewClientTimesheetdata,
  FOR,
  reloadData,
  InitialTimesheetData = null
}) => {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const clientAccentColor = selectedClientData?.AccentColor ?? "black";

  const {
    TEXT_CREATE_NEW_TIMESHEET,
    TEXT_MANUAL,
    TEXT_CLOCK_IN,
    TEXT_OR,
    TEXT_CREW_TIMESHEET,
    TEXT_MULTIPLE_EMPLOYEES,
    TEXT_MY_TEMPLATES,
    TEXT_NEW_TEMPLATE,
    TEXT_NO_TEMPLATES
  } = ClientEnglishFallback?.ClientTimesheetAddModal(multiLanguageData?.ClientTimesheetAddModal || {});

  // State

  const [view, setView] = useState("SELECT_JOBS");
  const [templateLists, setTemplateLists] = useState([]);
  const [isLoadingTemplates, setIsLoadingTemplates] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [modelState, setModelState] = useState(
    FOR === "INDIVIDUAL-CLOCKIN" ? VIEWS.INDIVIDUAL_CLOCKIN : VIEWS.HOME
  );

  const [templateId, setTemplateId] = useState(0);

  // Styles
  const optionBoxStyle = {
    padding: "10px",
    borderRadius: "10px",
    border: `1px solid ${clientAccentColor}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer"
  };

  // Effects
  useEffect(() => {
    if (FOR === "MANUALEDIT") {
      setModelState(VIEWS.MANUAL);
    } else if (FOR === "INDIVIDUAL-CLOCKIN") {
    }
    if (showAddClientTimesheetModal && modelState === VIEWS.HOME) {
      fetchTimesheetTemplates();
    }
  }, [showAddClientTimesheetModal, FOR]);

  // API Functions
  const fetchTimesheetTemplates = async () => {
    setIsLoadingTemplates(true);
    try {
      const fetchParams = {
        PageNr: 1,
        NrOfRecPerPage: 0,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: false,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientEmployeeId: selectedClientData?.ClientEmployeeId
          }
        ]
      };
      const response = await Postrequestcall(
        FETCH_CLIENT_TIMESHEET_TEMPLATES_V2_NEW,
        fetchParams,
        loginData?.accessToken
      );
      setTemplateLists(response?.data?.data ?? []);
    } catch (error) {
      console.error("Error fetching timesheet templates:", error);
    } finally {
      setIsLoadingTemplates(false);
    }
  };

  const duplicateTemplate = async (template) => {
    try {
      setIsLoadingTemplates(true);
      setSelectedTemplate(template);
      if (!template?.id) return;
      const saveParams = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            Name: `${template.name} - Copy`,
            Type: template?.type,
            ClientEmployeeId: selectedClientData?.ClientEmployeeId,
            ClientJobId: Number(template?.clientJobId),
            EmployeeIdList: template?.templateEmployeesList
              ?.map((emp) => emp.clientEmployeeId)
              .join(","),
            ActivityIdList: template?.templateActivitiesList
              ?.map((act) => act.activityId)
              .join(","),
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      await Postrequestcall(SAVE_CLIENT_TIMESHEET_TEMPLATE, saveParams, loginData?.accessToken);
      fetchTimesheetTemplates();
      setSelectedTemplate(null);
    } catch (error) {
      console.error("Error duplicating template:", error);
    } finally {
      setIsLoadingTemplates(false);
    }
  };

  const deleteTemplate = async (template) => {
    try {
      setIsLoadingTemplates(true);
      setSelectedTemplate(template);
      if (!template?.id) return;
      const deleteParams = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: false,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: [
          {
            Id: template?.id
          }
        ]
      };
      await Postrequestcall(
        DELETE_CLIENT_TIMESHEET_TEMPLATES,
        deleteParams,
        loginData?.accessToken
      );
      fetchTimesheetTemplates();
      setSelectedTemplate(null);
    } catch (error) {
      console.error("Error deleting template:", error);
    } finally {
      setIsLoadingTemplates(false);
    }
  };

  const handleEditTemplate = (template) => {
    setTemplateId(template?.id);
    setModelState(VIEWS.NEW_TEMPLATE);
  };

  const handleViewTemplate = (template) => {
    setTemplateId(template?.id);
    setModelState(VIEWS.VIEW_TEMPLATE);
  };

  const renderHomeView = () => (
    <>
      <Stack sx={{ gap: 2, display: "flex", width: "100%" }} direction="row" >
        <Stack
          sx={{ flex: 1 }}
          style={optionBoxStyle}
          onClick={() => {
            setModelState(VIEWS.MANUAL);
            setView("SELECT_JOBS");
          }}>
          <Stack sx={{ gap: 1, alignItems: "center" }}>
            <PersonIcon sx={{ fontSize: "90px", color: clientAccentColor }} />
            <Typography>{TEXT_MANUAL}</Typography>
          </Stack>
        </Stack>

        <Stack
          sx={{ flex: 1 }}
          style={optionBoxStyle}
          onClick={() => setModelState(VIEWS.INDIVIDUAL_CLOCKIN)}>
          <Stack sx={{ gap: 1, alignItems: "center" }}>
            <WatchLaterRoundedIcon sx={{ fontSize: "90px", color: clientAccentColor }} />
            <Typography>{TEXT_CLOCK_IN}</Typography>
          </Stack>
        </Stack>
      </Stack>

      <Divider sx={{ mt: 1, mb: 1 }}>{TEXT_OR}</Divider>

      <Stack
        style={optionBoxStyle}
        onClick={() => {
          setModelState(VIEWS.CREW);
          setTemplateId(0);
        }}>
        <Stack  width="100%" sx={{ gap: 0.1, alignItems: "center" }}>
          <PersonIcon sx={{ fontSize: "90px", color: clientAccentColor }} />
          <Typography>{TEXT_CREW_TIMESHEET}</Typography>
          <Typography sx={{ color: BIGrey }}>{TEXT_MULTIPLE_EMPLOYEES}</Typography>
        </Stack>
      </Stack>

      <Stack sx={{ display: "flex",  mt: 1, justifyContent: "space-between" }} direction="row">
        <Typography sx={{ fontWeight: "bold" }}>
          {TEXT_MY_TEMPLATES}
        </Typography>
        <Typography
          onClick={() => {
            setModelState(VIEWS.NEW_TEMPLATE);
            setTemplateId(0);
          }}
          sx={{ fontWeight: "bold", cursor: "pointer", color: clientAccentColor }}>
          {TEXT_NEW_TEMPLATE}
        </Typography>
      </Stack>

      {renderTemplateList()}
    </>
  );

  const renderTemplateList = () => {
    if (isLoadingTemplates) {
      return <TimesheetSkeletonLoader variant="templateList" count={3} />;
    }

    if (templateLists?.length === 0) {
      return (
        <Stack sx={{ display: "flex", mt: 1, alignItems: "center", justifyContent: "center", width: "100%" }}>
          <Typography sx={{ color: BIGrey, textAlign: "center", width: "100%" }}>{TEXT_NO_TEMPLATES}</Typography>
        </Stack>
      );
    }

    return (
      <Stack direction="row" sx={{ gap: 1, mt: 1, scrollbarWidth: "none", overflowX: "auto" }}>
        {templateLists.map((item) => (
          <TemplateItem
            key={item.id}
            data={item}
            onEdit={handleEditTemplate}
            onDuplicate={duplicateTemplate}
            onDelete={deleteTemplate}
            setModelState={setModelState}
            onView={handleViewTemplate}
          />
        ))}
      </Stack>
    );
  };

  const renderContent = () => {
    switch (modelState) {
      case VIEWS.HOME:
        return renderHomeView();
      case VIEWS.MANUAL:
        return (
          <ClientTimesheetManualComponent
            modelState={modelState}
            setView={setView}
            view={view}
            setModelState={setModelState}
            handleClose={handleClose}
            reloadData={reloadData}
            data={timeSheetData}
            FOR={FOR}
          />
        );

      case VIEWS.INDIVIDUAL_CLOCKIN:
        return (
          <ClientTimesheetClockinComponent
            modelState={modelState}
            setView={setView}
            view={view}
            reloadData={reloadData}
            InitialTimesheetData={InitialTimesheetData}
            setModelState={setModelState}
            setViewClientTimesheetdata={setViewClientTimesheetdata} // this is to set the view the timesheet id  nuull of prevent the jobs mismatch
            handleClose={handleClose}
            setTimeSheetData={setTimeSheetData}
            timeSheetData={timeSheetData}
            FOR={FOR}
          />
        );

      case VIEWS.CREW:
        return (
          <ClientTimesheetCrewComponent
            modelState={modelState}
            setModelState={setModelState}
            reloadData={reloadData}
            handleClose={handleClose}
            templateId={templateId}
          />
        );

      case VIEWS.NEW_TEMPLATE:
        return (
          <CrewTemplateForm
            isOpen={modelState}
            setModelState={setModelState}
            onClose={() => {
              setModelState("HOME");
              fetchTimesheetTemplates();
            }}
            templateId={templateId}
            from=""
          />
        );
      case VIEWS.EDIT_TEMPLATE:
        return (
          <CrewTemplateForm
            isOpen={modelState}
            setModelState={setModelState}
            onClose={() => {
              setModelState("HOME");
              fetchTimesheetTemplates();
            }}
            templateId={templateId}
            from=""
          />
        );
      case VIEWS.VIEW_TEMPLATE:
        return (
          <CrewTemplateView
            isOpen={modelState}
            templateId={templateId}
            setModelState={setModelState}
            onClose={() => {
              setModelState("HOME");
              fetchTimesheetTemplates();
            }}
          />
        );

      default:
        return null;
    }
  };

  // Determine if background should be grey
  const isGreyBackground =
    (modelState === VIEWS.INDIVIDUAL_CLOCKIN && view == "LISTING") ||
    (modelState === VIEWS.MANUAL && view == "LISTING");

  return (
    <Modal
      open={showAddClientTimesheetModal}
      onClose={() => {
        if (modelState == VIEWS.INDIVIDUAL_CLOCKIN || modelState === VIEWS.CREW) {
          return;
        }
        handleClose();
      }}
      aria-labelledby="timesheet-modal-title"
      aria-describedby="timesheet-modal-description">
      <Box
        sx={{
          backgroundColor: isGreyBackground ? "#e4e4e4" : "white",
          padding: {
            xs: "10px",
            xl: "15px",
            lg: "15px",
            md: "15px",
            sm: "10px"
          },
          maxWidth: modelState === VIEWS.VIEW_TEMPLATE ? "0px" : "600px"
        }}
        className="client-modal-responsive">
        {modelState === VIEWS.HOME && (
          <Stack sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}  direction="row">
            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
              {TEXT_CREATE_NEW_TIMESHEET}
            </Typography>
            <IconButton size="small" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
        )}
        {renderContent()}
      </Box>
    </Modal>
  );
};

export default ClientTimesheetAddModal;

